import { render, staticRenderFns } from "./UTag.vue?vue&type=template&id=04c0df16&scoped=true"
import script from "./UTag.vue?vue&type=script&lang=js"
export * from "./UTag.vue?vue&type=script&lang=js"
import style0 from "./UTag.vue?vue&type=style&index=0&id=04c0df16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0df16",
  null
  
)

export default component.exports